import { BankAccountInfo } from "./BankAccountInfo";
import { Liquidation } from "@/@modules/tarif-covid/interfaces/Liquidation";
import { WorkerVC } from "@/@modules/tarif-covid/interfaces/WorkerVC";

export enum FinancialFlowState {
  Preserved = "PRESEVED",
  Rejected = "REJECTED",
  NotCashable = "NOT_CASHABLE",
  ToEmit = "TO_EMIT",
  Issued = "ISSUED",
  Cashed = "CASHED",
  PhysicalReturn = "PHYSICAL_RETURN",
  ReturnByAccountant = "RETURN_BY_ACCOUNTANT",
  Outstanding = "OUTSTANDING",
}

export interface FinancialFlow {
  cashingDate?: Date;
  amount?: number;
  foreignBankAccount?: BankAccountInfo;
  communication?: string;
  state?: FinancialFlowState;
  returnMotivation?: string;
  liquidation?: Liquidation;
  paymentNr?: string;
  workerVC?: WorkerVC;
  showDetails?: boolean;
  nativeWorker?: NativeWorker;
}

export interface NativeWorker {
  firstName: string;
  lastName: string;
  cBE: string;
}
